import React from 'react';
import { ReactComponent as SubsectionLink } from './Images/SubsectionLink.svg';
import styles from './TemplateBuilderComponents.module.css';

export const TemplateSubsectionLink = () => (
  <div className={styles.subsectionLink}>
    <SubsectionLink />
  </div>
);
